import React from 'react';
import {
  Typography, Card, Grid, CardHeader, CardContent,
} from '@material-ui/core/';
import { withStyles } from '@material-ui/core/styles';
import Note from '@material-ui/icons/Note';

import { connect } from 'react-redux';
import { dashboard } from '../../redux/actions/tracker/dashboardActions';

import DashboardCard from '../util/DashboardCard/DashboardCard';

const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(900 + theme.spacing.unit * 3 * 2)]: {
      width: 900,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[200],
  },
  card: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing.unit * 2,
  },
});

class MSCard extends React.Component {

  constructor(props) {

    super(props);
    this.state = {
      cards: [],
      companyCards: [],
    };

  }

  componentWillMount() {

    let { cards, companyCards } = this.state;
    const { user, dashboard } = this.props;

    dashboard(user.context.idHolding)
      .then(temp => (
        cards = [
          {
            title: 'Notas inseridas',
            content: temp.lstDashCompanies.length === 0 ? 0 : temp.lstDashCompanies[0].totalInserted,
            icon: Note,
            textColor: '#fff',
            bgColor: '#446cb3',

          },
          {
            title: 'Notas com fluxo finalizado',
            content: temp.invoiceFinished,
            icon: Note,
            textColor: '#fff',
            bgColor: '#00b16a',
          },
          {
            title: 'Notas com fluxo em aberto',
            content: temp.invoiceUnfinished,
            icon: Note,
            textColor: '#fff',
            bgColor: '#f4d03f',
          },
          {
            title: 'Notas com o tempo expirado',
            content: temp.timeExpired,
            icon: Note,
            textColor: '#fff',
            bgColor: '#d91e18',
          },

        ],
        temp.lstDashCompanies.length !== 0 && temp.lstDashCompanies.map(company => (
          companyCards.push({
            title: company.companyName,
            content: [`Usuarios: ${company.totalUsers}`, ` / Notas: ${company.invoiceCompany}`],
            icon: 'building',
          })
        )),
        this.setState({ cards, companyCards })
      ));

  }

  renderCards() {

    const { classes } = this.props;
    const { cards, companyCards } = this.state;

    return (
      <div>

        <div className="row" style={{ marginTop: 10 }}>
          {cards.map(tier => (
            <div className="col-lg-3 col-xs-12">
              <DashboardCard title={tier.title} value={tier.content} textColor={tier.textColor} icon={tier.icon} bgColor={tier.bgColor} />
            </div>

          ))}

        </div>


        {/* <div className="row" style={{ marginTop: 10 }}>
          {companyCards.map(tier => (
            <div className="col-lg-4 col-xs-12">
              <DashboardCard title={tier.title} value={tier.content} />
            </div>

          ))}
        </div> */}


      </div>
    );

  }


  render() {

    return (
      <div>
        {this.renderCards()}
      </div>
    );

  }

}

const mapStateToProps = state => ({
  user: state.auth.user,
  loading: state.appReducer.loading,
});

const mapDispatchToProps = {
  dashboard,
};


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MSCard));



// WEBPACK FOOTER //
// ./src/components/tracker/MSCard.js